import {
  ClientType,
  CredentialEntity,
  LoginWithTokenFnReq,
  LoginWithTokenFnRes,
  ServiceProviderMap,
} from '@uploadcam/common';
import { HttpsCallable } from 'firebase/functions';
import { Auth, signInWithCustomToken } from 'firebase/auth';
import { CheckLoginPostConditionsInteractor } from './check-login-post-conditions.interactor';

export const CREDENTIALS_KEY = 'uploadcam_credentials';

export class AuthenticateWithCredentialsInteractor {
  constructor(
    private readonly auth: Auth,
    private readonly checkLoginPostConditions: ServiceProviderMap<CheckLoginPostConditionsInteractor>,
    private readonly clientIds: ServiceProviderMap<string>,
    private readonly loginWithTokenFn: HttpsCallable<LoginWithTokenFnReq, LoginWithTokenFnRes>,
    private readonly storage: Storage,
  ) {}

  public async execute(creds: CredentialEntity): Promise<void> {
    const clientId = this.clientIds[creds.provider];

    // Exchange OAuth access token for Firebase Auth JWT ID token
    const loginRes = await this.loginWithTokenFn({
      auth: {
        provider: creds.provider,
        clientId,
        clientType: ClientType.Web,
        accessToken: creds.accessToken,
        metadata: creds.metadata,
      },
    });

    // Save credentials in `Storage`
    this.storage.setItem(CREDENTIALS_KEY, JSON.stringify(creds));

    // Login in Firebase Auth with the custom JWT ID token, this will give us access to Firestore
    await signInWithCustomToken(this.auth, loginRes.data.idToken);

    // Check post conditions, allows cancelling the login
    await this.checkLoginPostConditions[creds.provider].execute(creds);
  }
}
